import React from 'react';
import Menu from './../menu'

const Header: React.FC = () => {
    return (
        <div>
            <Menu />
        </div>

    )
}

export default Header;